import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {AccountCategoryDTO} from '../model/accountCategoryDTO';


@Injectable({
  providedIn: 'root'
})
export class AccountCategoryService {

  private readonly path = environment.baseUrl + environment.apiPrefix + 'account-categories';

  constructor(private http: HttpClient) {
  }

  get() {
    return this.http.get<Array<AccountCategoryDTO>>(`${this.path}`);
  }

}
